// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---node-modules-gatsby-theme-garden-src-templates-local-file-js": () => import("./../../../node_modules/gatsby-theme-garden/src/templates/local-file.js" /* webpackChunkName: "component---node-modules-gatsby-theme-garden-src-templates-local-file-js" */)
}

